export const DEAL_CARD_SURFACE_CONFIG = {
  appDeals: {
    dateLocale: 'en-GB',
    titleSource: 'dealTitle',
    showAmount: true,
    showRound: true,
    showIndustries: true,
    recipientCompany: {
      visible: true,
      accessMode: 'full',
    },
    investors: {
      mode: 'split',
      fallbackLeadKey: 'app:deals.investorsNotListed',
      fallbackLeadDefault: 'Not listed',
    },
    article: {
      enabled: true,
      expandedParagraphs: 'all',
      lazyLoad: false,
    },
  },
  homeLatest: {
    dateLocale: 'en-US',
    titleSource: 'dealTitle',
    showAmount: true,
    showRound: true,
    showIndustries: true,
    recipientCompany: {
      visible: true,
      accessMode: 'membershipDefault',
    },
    investors: {
      mode: 'merged',
    },
    article: {
      enabled: true,
      expandedParagraphs: 2,
      lazyLoad: false,
    },
    refetchOnProfessionalUpgrade: true,
  },
  earlyStageInline: {
    dateLocale: 'en-US',
    titleSource: 'dealTitle',
    showAmount: true,
    showRound: true,
    showIndustries: true,
    recipientCompany: {
      visible: true,
      accessMode: 'membershipDefault',
    },
    investors: {
      mode: 'merged',
    },
    article: {
      enabled: true,
      expandedParagraphs: 2,
      lazyLoad: false,
    },
    refetchOnProfessionalUpgrade: true,
  },
  appInvestorProfile: {
    dateLocale: 'en-US',
    titleSource: 'dealTitle',
    showAmount: true,
    showRound: false,
    showIndustries: false,
    recipientCompany: {
      visible: true,
      accessMode: 'membershipDefault',
    },
    investors: {
      mode: 'none',
    },
    article: {
      enabled: true,
      expandedParagraphs: 'all',
      lazyLoad: true,
    },
  },
  publicInvestorProfile: {
    dateLocale: 'en-US',
    titleSource: 'dealTitle',
    showAmount: true,
    showRound: false,
    showIndustries: false,
    recipientCompany: {
      visible: true,
      accessMode: 'membershipDefault',
    },
    investors: {
      mode: 'none',
    },
    article: {
      enabled: true,
      expandedParagraphs: 'all',
      lazyLoad: false,
    },
  },
  dashboardLatest: {
    dateLocale: 'en-GB',
    titleSource: 'dealTitle',
    showAmount: true,
    showRound: true,
    showIndustries: true,
    recipientCompany: {
      visible: true,
      accessMode: 'membershipDefault',
    },
    investors: {
      mode: 'none',
    },
    article: {
      enabled: false,
      expandedParagraphs: 0,
      lazyLoad: false,
    },
  },
  aiFundingPreview: {
    dateLocale: 'en-GB',
    titleSource: 'recipientCompanyOrFallback',
    titleFallback: 'Company not listed',
    showAmount: true,
    showRound: true,
    showIndustries: false,
    recipientCompany: {
      visible: false,
      accessMode: 'full',
    },
    investors: {
      mode: 'countOnly',
    },
    article: {
      enabled: false,
      expandedParagraphs: 0,
      lazyLoad: false,
    },
  },
};
